<template>
  <el-header height="">
    <div class="header">
      <div>
        <button>
          <i class="el-icon-s-fold" @click="Showaside"></i>
        </button>
      </div>
      <div>
        <div>
          <i class="el-icon-time"></i>
          <p>{{ gettime }}</p>
        </div>
        <el-dropdown @command="tapMenu" style="cursor: pointer">
                <span>
                  <i class="el-icon-user-solid"></i>
                </span>
          <p>
            {{ $store.state.info.name }}
          </p>
          <el-dropdown-menu
              slot="dropdown"
              style="width: 150px"
          ><el-dropdown-item command="out">退出
            </el-dropdown-item>
          </el-dropdown-menu>
          <i>|</i>
          <p @click="gopage('homeindex')">返回</p>
        </el-dropdown>
      </div>
    </div>
  </el-header>
</template>

<script>
import {Loginout} from "@/api/http.js";
import {getAuthor} from "@/utils/author";

export default {
  name: 'MainHeader',
  data() {
    return {
      // 当前时间
      gettime: '',
    }
  },
  watch:{
	'theme' (to, from) {
		console.log("YYEMIANQIEHUAN");
	
	}
  },
  methods: {
    tapMenu(type) {
      if (type === 'out') {
        this.goOut()
      }
    },
    goOut() {
      Loginout({token: sessionStorage.getItem('tokens')})
      this.$router.push("/login")
    },
    Showaside() {
      this.$emit('change')
    },
    // 跳转
    gopage(pageName) {
      this.$router.push({name: pageName})
    },
    // 获取时间
    getTime() {
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds()
      this.gettime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
    },
    currentTime() {
      setInterval(this.getTime, 500)
    }
  },
  created() {
    this.currentTime()
  }
}
</script>

<style lang="less" scoped>
.el-header {
  display: flex;
  height: 70px;
  align-items: center;
  background-color: #ececec;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div:nth-child(1) {

      button {
        width: 35px;
        height: 35px;
        border: none;
        border-radius: 4px;
        padding: 0px;

        /deep/ .el-icon-s-fold {
          font-size: 20px;
          color: #000000;
        }

      }

      button:hover {
        transition: 0.8s;
        background-color: #d4d4d4;
      }

    }

    div:nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;

      div:nth-child(1) {
        display: flex;
        margin-right: 40px;

        p,
        i {
          font-size: 13px;
          margin-left: 5px;
        }

      }

      div:nth-child(2) {
        padding: 0 20px;
        min-width: 150px;
        height: 30px;
        border-radius: 19px;
        background-color: #fcfeff;

        span {
          display: flex;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          background-color: #3982f6;

          i {
            color: #fff;
          }

        }

        i {
          margin: 0 10px 0 10px;
        }

      }
    }
  }
}
</style>